import LegalPage, { H, LEGAL_ENTITY } from './LegalPage';

export default function Privacy() {
  return (
    <LegalPage title="Политика конфиденциальности" updated="30.10.2026">
      <p>{LEGAL_ENTITY.name} («мы», «AdaMar») — оператор персональных данных сервиса adamar.app. Политика описывает, какие данные мы обрабатываем, зачем и как их удалить. Применимое право — Кыргызская Республика (Закон КР «Об информации персонального характера»).</p>

      <H>1. Какие данные мы обрабатываем</H>
      <p><b>Данные аккаунта:</b> email, имя, роль (заказчик/креатор), организация. <b>Данные Instagram при подключении аккаунта:</b> идентификатор и имя пользователя Instagram, публичная статистика аккаунта и, при вашем согласии через Instagram, статистика аудитории (возраст/пол/география в агрегированном виде). Токены доступа Instagram хранятся только на сервере, действуют до 60 дней и не передаются третьим лицам. <b>Технические данные:</b> журналы ошибок и использования сервиса.</p>

      <H>2. Общедоступные данные каталога</H>
      <p>Сервис содержит аналитический каталог публичных Instagram-аккаунтов брендов и авторов контента Кыргызстана, составленный из <b>общедоступной</b> информации (открытые профили, публикации, подписи). Если вы — владелец аккаунта и хотите исключить его из каталога, напишите на {LEGAL_ENTITY.email} — мы удалим профиль в течение 30 дней.</p>

      <H>3. Цели обработки</H>
      <p>Предоставление сервиса (аналитика, кабинет, каталог), подтверждение владения аккаунтами, связь с вами, исполнение требований закона.</p>

      <H>4. Кому передаются данные (процессоры)</H>
      <p>Инфраструктурные подрядчики, обрабатывающие данные по нашему поручению: Supabase (база данных и аутентификация), Vercel (хостинг), Apify (сбор общедоступных данных), Meta Platforms (авторизация Instagram). Серверы этих провайдеров находятся за пределами Кыргызской Республики — регистрируясь, вы даёте согласие на такую <b>трансграничную передачу</b>. Мы не продаём персональные данные.</p>

      <H>5. Сроки хранения</H>
      <p>Данные аккаунта — пока существует аккаунт; токены Instagram — до 60 дней или до отключения; журналы — до 90 дней.</p>

      <H>6. Ваши права</H>
      <p>Вы вправе запросить доступ к своим данным, их исправление или удаление: {LEGAL_ENTITY.email}. Удаление аккаунта — см. <a href="/data-deletion" style={{ color: 'var(--accent, #4a9eff)' }}>инструкцию по удалению данных</a>.</p>

      <H>7. Cookies</H>
      <p>Мы используем только технически необходимые cookies (сессия входа). Рекламных и сторонних трекеров нет.</p>

      <H>8. Изменения</H>
      <p>Об изменениях политики мы сообщаем на этой странице. Вопросы: {LEGAL_ENTITY.email}, {LEGAL_ENTITY.address}.</p>
    </LegalPage>
  );
}
